import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE AUTONOMOUS CHILD VISUAL SYSTEM™',
  ideal: 'Families with children ages 3-12 who want the routine to be visible instead of repeated',
  was: '$38',
  features: ['Complete 50-page eBook (A4, print-ready)', '6 routine volumes (Wake Up → Sleep)', 'Visual templates, icons & flashcards', 'Parent scripts & progress trackers', '5 Free Bonuses included', '30-Day Challenge protocol', '♾️ Lifetime access & future updates'],
  cta: 'Get the visual system now'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-114" data-mp="3vzyncicgrb3m">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-115" data-mp="4smd6n9zzxx7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-blush/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(124,58,237,0.4)]" style={{
        paddingTop: "5px",
        paddingBottom: "5px"
      }} data-id="element-116" data-mp="9ta3t7ubecqw">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-117" data-mp="3n5ai2s6w1tet">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-118" data-mp="3rz6cxlruv05r">
            <span className="font-semibold text-plum/80" data-id="element-119" data-mp="2uj99fanw09qc">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-120" data-mp="2zgra6drr3in9">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "30px"
          }} data-id="element-121" data-mp="2zfzllmwkml6h">{plan.was}</span>
            <div className="flex justify-center" style={{
            paddingBottom: "26px",
            paddingTop: "20px"
          }} data-id="element-122" data-mp="2rei8ybdycboj">
              <div className="relative inline-block font-display leading-none text-blush-deep" data-id="element-123" data-mp="2mfxgwz8usyb6">
                <span className="absolute right-full top-1/2 mr-1 -translate-y-1/2 font-black" style={{
                fontSize: "40px",
                fontFamily: "Montserrat, sans-serif"
              }} data-id="element-124" data-mp="318iluzfh6l7t">
                  $
                </span>
                <span className="block" style={{
                fontSize: "72px",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: "800"
              }} data-id="element-125" data-mp="23ixgglq5orq4">
                  19
                </span>
                <span className="absolute left-full top-1/2 ml-2 -translate-y-1/2 font-black" style={{
                fontSize: "24px",
                fontFamily: "Montserrat, sans-serif"
              }} data-id="element-126" data-mp="2ihhqeldkd7t0">
                  USD
                </span>
              </div>
            </div>
            <p className="mt-1 text-xs font-semibold text-blush" data-id="element-127" data-mp="3ows2zo1quksm">
              One-time payment · No monthly subscription
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" style={{
            fontWeight: "600"
          }} data-id="element-128" data-mp="8sp8xh404jk">
              Payment will be processed in your local currency.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-129" data-mp="3ngejjjvl6m08">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-130" data-mp="3rhq5nff94p3o">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-131" data-mp="j0ljev7wzvsv" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-132" data-mp="o22hkiz0l45r">
            <CTAButton size="md" data-id="element-133" data-mp="a7ian087s74k">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-134" data-mp="e9wspi4272us">
            You save $176 (90% OFF)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-135" data-mp="11yob5hruk6ud">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-136" data-mp="3f7sc3zu40bvu">
                <Icon className="h-4 w-4 text-grape" data-id="element-137" data-mp="3a8p5iayhdxlr" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-138" data-mp="35aduvy0d3j2h" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-139" data-mp="359maljc7t7ri">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-140" data-mp="1scf92onl41r" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-141" data-mp="1ugirjin411i">
            <span className="font-display font-bold text-plum" data-id="element-142" data-mp="3szglvwgvyo9n">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the system does not fit your family or does not
            make your routine simpler, request your refund and we return 100% of your money. We
            want you to try it with complete peace of mind, risk-free.
          </p>
        </div>
      </div>
    </section>;
}